import { render, staticRenderFns } from "./extensionFailed.vue?vue&type=template&id=29945a98&scoped=true&"
import script from "./extensionFailed.vue?vue&type=script&lang=js&"
export * from "./extensionFailed.vue?vue&type=script&lang=js&"
import style0 from "./extensionFailed.vue?vue&type=style&index=0&id=29945a98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29945a98",
  null
  
)

export default component.exports